import { api as wiredApi } from './index';

/**
 * A rider's ringtones on InGo's API (armkit/ring; InGo ADR 0045, this app's
 * ADR 0014): the tones the office switched on, the default, whether the
 * rider may choose, and their choice. The rider is the token.
 *
 * Each answer is the same shape: `{ default_id, chosen_id, may_choose,
 * tones: [{ id, name, duration_ms, size_bytes, sha256, file }] }`, where
 * `file` is the tone's path under the API root.
 */
export function createRingTones({ api }) {
  return {
    /** `GET rider/me/ring-tones`. */
    async list() {
      const { data } = await api.get('/rider/me/ring-tones');

      return data;
    },

    /**
     * `PUT rider/me/ring-tone`, `null` for the default. Refused
     * `RING_CHOICE_CLOSED` when the office set one tone for everyone, and
     * `RING_TONE_INACTIVE` for a tone no longer offered.
     */
    async choose(id) {
      const { data } = await api.put('/rider/me/ring-tone', { tone_id: id ?? null });

      return data;
    },
  };
}

export const ringTones = createRingTones({ api: wiredApi });
